export class Rectangle extends PIXI.Rectangle {

    public containsPoint(point: PIXI.Point): boolean {
        return this.contains(point.x, point.y);
    }

    public containsRectangle(other: PIXI.Rectangle): boolean {
        return other.x >= this.x &&
            other.y >= this.y &&
            other.right <= this.right &&
            other.bottom <= this.bottom;
    }

    public intersects(other: PIXI.Rectangle): boolean {
        return !(
            other.right <= this.x ||
            other.bottom <= this.y ||
            other.x >= this.right ||
            other.y >= this.bottom
        );
    }
}


// WEBPACK FOOTER //
// ./src/framework/geom/Rectangle.ts